import { useRef } from "react";
import { ArrowLeft, ArrowRight, ShoppingBag } from "lucide-react";
import { FadeUp } from "./motion";
import { LEXICON as COVERS, amazonUrl } from "../data/library";

export default function CoverGallery() {
  const trackRef = useRef(null);
  const scrollBy = (dir) =>
    trackRef.current?.scrollBy({ left: dir * trackRef.current.clientWidth * 0.8, behavior: "smooth" });

  return (
    <FadeUp data-testid="cover-gallery" className="mt-6 border border-line bg-ink">
      <div className="flex items-center justify-between border-b border-line px-6 py-5 sm:px-8">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">
          The Lexicon — <span className="text-bone">{COVERS.length} volumes</span> · tap a cover to buy
        </p>
        <div className="flex gap-2">
          <button
            data-testid="cover-gallery-prev"
            aria-label="Previous covers"
            onClick={() => scrollBy(-1)}
            className="border border-line p-2.5 text-ash transition-colors duration-300 hover:border-vermilion hover:text-vermilion"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={1.5} />
          </button>
          <button
            data-testid="cover-gallery-next"
            aria-label="Next covers"
            onClick={() => scrollBy(1)}
            className="border border-line p-2.5 text-ash transition-colors duration-300 hover:border-vermilion hover:text-vermilion"
          >
            <ArrowRight className="h-4 w-4" strokeWidth={1.5} />
          </button>
        </div>
      </div>
      <div
        ref={trackRef}
        data-lenis-prevent
        className="cover-track flex snap-x snap-mandatory gap-4 overflow-x-auto px-6 py-8 sm:px-8"
      >
        {COVERS.map(([id, title, asin], i) => (
          <figure
            key={id}
            data-testid={`cover-${id}`}
            className="group w-[9.5rem] shrink-0 snap-start sm:w-[11rem]"
          >
            <a
              href={amazonUrl({ title, asin, lexicon: true })}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`buy-cover-${id}`}
              aria-label={`Buy the ${title} volume on Amazon`}
              className="relative block overflow-hidden border border-line"
            >
              <img
                src={`/assets/covers/${id}.jpg`}
                alt={`${title} — Aether Verge Collective`}
                loading="lazy"
                className="aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-2 top-2 bg-ink/80 px-2 py-1 font-mono text-[9px] tracking-[0.2em] text-ash backdrop-blur">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="absolute inset-x-0 bottom-0 flex translate-y-full items-center justify-center gap-2 bg-vermilion py-2 font-mono text-[9px] uppercase tracking-[0.2em] text-ink transition-transform duration-300 group-hover:translate-y-0">
                <ShoppingBag className="h-3 w-3" strokeWidth={1.5} />
                Buy on Amazon
              </span>
            </a>
            <figcaption className="mt-3 flex items-baseline justify-between gap-2">
              <span className="font-serif text-lg text-bone">{title}</span>
              <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-smoke">Vol.</span>
            </figcaption>
          </figure>
        ))}
      </div>
    </FadeUp>
  );
}
